/// <reference path="../../Controls/CertificateDialog/CertificateDialogBase/CertificateDialogBase.ts"/>
/// <reference path="../../Controls/CertificateDialog/CertificateDialogBase/CertificateDialogModel.ts"/>
/// <reference path="../../Controls/CertificateDialog/SetPrivateKeyPassword/SetPrivateKeyPassword.ts"/>
/// <reference path="../../Controls/CertificateDialog/CreatePrivateKey/CreatePrivateKey.ts"/>
/// <reference path="../../Controls/CertificateDialog/UploadCSRAndRequestCertificate/UploadCSRAndRequestCertificate.ts"/>
/// <reference path="../../Controls/CertificateDialog/SavePKCSFile/SavePKCSFile.ts"/>
/// <reference path="../../Controls/CertificateDialog/SetPKCSFilePassword/SetPKCSFilePassword.ts"/>
/// <reference path="../../Controls/CertificateDialog/SavePrivateKey/SavePrivateKey.ts"/>
/// <reference path="../../Commands/CreateAndSavePkcsFileCommand.ts"/>
/// <reference path="../../Commands/CreatePrivateKeyCommand.ts"/>
/// <reference path="../../Commands/GetKeyPairFromFileCommand.ts"/>
/// <reference path="../../Commands/ReadPrivateKeyFileCommand.ts"/>
/// <reference path="../../Commands/RequestCertificateCommand.ts"/>
/// <reference path="../../Commands/SavePrivateKeyToFileCommand.ts"/>

module EEX.McEc.Apps {

    import SetPrivateKeyPasswordModel = McEc.Controls.CertificateDialog.SetPrivateKeyPasswordModel;
    import SetPrivateKeyPasswordView = McEc.Controls.CertificateDialog.SetPrivateKeyPasswordView;
    import CreatePrivateKeyModel = McEc.Controls.CertificateDialog.CreatePrivateKeyModel;
    import CreatePrivateKeyView = McEc.Controls.CertificateDialog.CreatePrivateKeyView;
    import UploadCsrAndRequestCertificateModel = McEc.Controls.CertificateDialog.UploadCSRAndRequestCertificateModel;
    import UploadCsrAndRequestCertificateView = McEc.Controls.CertificateDialog.UploadCSRAndRequestCertificateView;
    import SavePkcsFileModel = McEc.Controls.CertificateDialog.SavePkcsFileModel;
    import SavePkcsFileView = McEc.Controls.CertificateDialog.SavePkcsFileView;
    import CertificateDialogModel = McEc.Controls.CertificateDialog.CertificateDialogModel;
    import SetPKCSFilePasswordModel = McEc.Controls.CertificateDialog.SetPKCSFilePasswordModel;
    import SetPKCSFilePasswordView = McEc.Controls.CertificateDialog.SetPKCSFilePasswordView;
    import SavePrivateKeyModel = McEc.Controls.CertificateDialog.SavePrivateKeyModel;
    import SavePrivateKeyView = McEc.Controls.CertificateDialog.SavePrivateKeyView;
    import UserInfo = AppKitchen.Api.Models.UserInfo;
    import CreatePrivateKeyCommand = McEc.Commands.CreatePrivateKeyCommand;
    import RequestCertificateCommand = McEc.Commands.RequestCertificateCommand;
    import SavePrivateKeyToFileCommand = McEc.Commands.SavePrivateKeyToFileCommand;
    import CreateAndSavePkcsFileCommand = McEc.Commands.CreateAndSavePkcsFileCommand;

    // ReSharper disable once InconsistentNaming
    export interface CertificateCreateDialogOptions extends AppKitchen.AppBaseOptions {
        userInfo: UserInfo,
        authorityId: string,
        close: (certificateKey?: number, store?: Pki.Store, certificateFile?: string) => void,
    }

    export class CertificateCreateDialogApp extends AppKitchen.AppBase<CertificateCreateDialogOptions> {

        public start() {
            let userInfo = this.options.userInfo;

            let model = new CertificateDialogModel({
                userInfo: userInfo,
                currentProcessStep: 1,
                totalProcessSteps: 6,
                certificateAttributes: {
                    commonName: userInfo.Id
                }
            });

            let createAndSavePkcsFileCommand = new CreateAndSavePkcsFileCommand();
            let createPrivateKeyCommand = new CreatePrivateKeyCommand();
            let savePrivateKeyToFileCommand = new SavePrivateKeyToFileCommand();
            let requestCertificateCommand = new RequestCertificateCommand(this.options.authorityId, false);
            //let getKeyPairFrimFileCommand = new GetKeyPairFrimFileCommand();
            //let readPrivateKeyFileCommand = new ReadPrivateKeyFileCommand();

            //let chooseKeyPairSourceModel = new ChooseKeyPairSourceModel(model, 1);
            //let chooseKeyPairSourceView = new ChooseKeyPairSourceView(chooseKeyPairSourceModel, this.el);

            //let uploadPrivateKeyModel = new UploadPrivateKeyModel(model, 2, readPrivateKeyFileCommand, getKeyPairFrimFileCommand);
            //let uploadPrivateKeyView = new UploadPrivateKeyView(uploadPrivateKeyModel, this.el);

            let createPrivateKeyModel = new CreatePrivateKeyModel(model, 1, createPrivateKeyCommand);
            let createPrivateKeyView = new CreatePrivateKeyView(createPrivateKeyModel, this.el);

            let setPrivateKeyPasswordModel = new SetPrivateKeyPasswordModel(model, 2);
            let setPrivateKeyPasswordView = new SetPrivateKeyPasswordView(setPrivateKeyPasswordModel, this.el);

            let savePrivateKeyModel = new SavePrivateKeyModel(model, 3, savePrivateKeyToFileCommand);
            let savePrivateKeyView = new SavePrivateKeyView(savePrivateKeyModel, this.el);

            let uploadCrsAndRequestCertificateModel = new UploadCsrAndRequestCertificateModel(model, 4, requestCertificateCommand);
            let uploadCsrAndRequestCertificateView = new UploadCsrAndRequestCertificateView(uploadCrsAndRequestCertificateModel, this.el);

            let setPkcsFilePasswordModel = new SetPKCSFilePasswordModel(model, 5);
            let setPkcsFilePasswordView = new SetPKCSFilePasswordView(setPkcsFilePasswordModel, this.el);  

            let savePkcsFileModel = new SavePkcsFileModel(model, 6, createAndSavePkcsFileCommand);
            let savePkcsFileView = new SavePkcsFileView(savePkcsFileModel, this.el);


            //chooseKeyPairSourceView.createNew(() => {
            //    createPrivateKeyView.render();
            //});

            //chooseKeyPairSourceView.chooseExisting(() => {
            //    uploadPrivateKeyView.render();
            //});

            //uploadPrivateKeyView.next(() => {
            //    uploadCsrAndRequestCertificateView.render();
            //});

            //uploadPrivateKeyView.prev(() => {
            //    chooseKeyPairSourceView.render();
            //});

            createPrivateKeyView.next(() => {
                setPrivateKeyPasswordView.render();
            }, true);

            //createPrivateKeyView.prev(() => {
            //    chooseKeyPairSourceView.render();
            //});

            setPrivateKeyPasswordView.next(() => {
                savePrivateKeyView.render();
            });

            savePrivateKeyView.next(() => {
                uploadCsrAndRequestCertificateView.render();
            });

            uploadCsrAndRequestCertificateView.next(() => {
                setPkcsFilePasswordView.render();
            }, true);

            uploadCsrAndRequestCertificateView.finish(() => {
                this.options.close();
            });

            setPkcsFilePasswordView.next(() => {
                savePkcsFileView.render();
            });

            savePkcsFileView.finish(() => {
                let certificateKey = model.get().certificateKey;
                let store = model.get().store;
                let certificateFile = model.get().certificateFile;
                this.options.close(certificateKey, store, certificateFile);
            });

            //chooseKeyPairSourceView.render();
            createPrivateKeyView.render();
        }
    }
}